import { forwardRef } from 'react';
import type { LinkProps } from './Link.types';

export const Link = forwardRef<HTMLAnchorElement, LinkProps>((props, ref) => {
  const { href, internal_link, open_in_new_tab, children, style, className, hasUnderline } = props;

  const target = open_in_new_tab ? '_blank' : undefined;
  const rel = internal_link ? undefined : 'noreferrer';

  return (
    <a
      ref={ref}
      href={href}
      rel={rel}
      target={target}
      style={style}
      className={className}
      {...(hasUnderline && { 'data-underline': true })}
    >
      {children}
    </a>
  );
});
